import { TradingOffer, TradingOffersSummary } from 'types/TradingOffer';

const calculateOffersSummary = (
  offers: TradingOffer[]
): TradingOffersSummary => {
  const offersCount = offers.length;
  const sharesCount = offers.reduce(
    (acc, offer) => acc + offer.sharesCount.total,
    0
  );
  const totalAmount = offers.reduce(
    (acc, offer) => acc + offer.sharesCount.total * offer.sharePrice,
    0
  );

  return { offersCount, sharesCount, totalAmount };
};

export default calculateOffersSummary;
